// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"ca7fdce3","706":"ca7fdce3"}[chunkId] + ".chunk.css";
};